
<template>
  <div>
    <van-nav-bar
      title="选择楼层区域"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <div class="p-2">
      <div class="flex overflow-x-auto space-x-1">
        <van-button
          class="shadow-md"
          round
          plain
          v-for="sday in days"
          :key="sday"
          :class="{ selected: sday === day }"
          @click="selectDay(sday)"
          ><span class="whitespace-nowrap"
            >{{ sday }}</span
          ></van-button
        >
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">分馆</span>
        <div
          class="
            mt-1
            grid grid-cols-3
            justify-evenly
            items-center
            gap-1
            middle-text
          "
        >
          <div
            v-for="lib in libraries"
            :key="lib.id"
            class="
              whitespace-nowrap
              leading-5
              rounded
              text-center
              shadow-md
              bg-white
            "
            :class="{ selected: lib.id === library.id }"
            @click="selectLibrary(lib)"
          >
            {{ lib.name }}
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">楼层</span>
        <div class="mt-1 grid grid-cols-3 justify-evenly gap-1">
          <div
            v-for="fl in floors"
            :key="fl.id"
            class="
              leading-1
              whitespace-nowrap
              p-1
              small-text
              rounded
              shadow-md
              bg-white
              flex
              justify-center
            "
            :class="{ selected: fl.id === floor.id }"
            @click="selectFloor(fl)"
          >
            <span>{{ fl.name }}</span>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="middle-text font-semibold text-gray-500">区域</span>
        <van-empty v-if="rooms.length == 0" description="无可用区域" />
        <div
          v-else
          class="mt-1 mb-4 grid grid-cols-2 justify-evenly items-center gap-1"
        >
          <div
            v-for="rm in rooms"
            :key="rm.id"
            class="leading-1 p-1 rounded text-center shadow-md bg-white"
            :class="{ selected: rm.id === room.id }"
            @click="selectRoom(rm)"
          >
            <div
              class="
                grid grid-cols-2
                justify-items-stretch
                small-text
                whitespace-nowrap
              "
            >
              <div class="place-self-auto">{{ rm.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-row class="fixed left-0 bottom-0 w-full bg-white small-text">
      <van-col span="6">
        <div class="text-center" @click="refresh">
          <van-icon name="replay" />
          <span class="block">刷新</span>
        </div>
      </van-col>
      <van-col span="18">
        <van-button
          :disabled="!room"
          block
          size="large"
          color="#49cfd4"
          @click="goBookingRoom"
          >确认选择</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import _ from "lodash";
import { myStorage } from "../utils/util";
import {
  getMyBookings,
  getRooms,
  getRoomOpenDays,
} from "@/service/home";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { Toast } from "vant";
export default {
  name: "chooseRoom",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      libraries: [],
      floors: [],
      rooms: [],
      days: [],
      day: dayjs().format("YYYY-MM-DD"),
      library: {},
      floor: {},
      room: {},
      latestFound: false,
    });
    onMounted(async () => {
      await getLatestBooking();
      await init();
    });

    watch(
      () => state.library,
      async (newValue) => {
        const allRooms = myStorage.get("allRooms");
        const foundRoom = _.find(allRooms, {
          id: newValue.id,
          isValid: 1,
          webhidden: 0,
        });
        let floors = foundRoom && foundRoom.floor;
        if (floors) {
          state.floors = floors.filter(
            (item) => item.isValid == 1 && item.webhidden === 0
          );
        } else {
          Toast.fail("暂无数据");
          return;
        }
        let latestFloor = myStorage.get("latestFloorOfRoom");
        state.floor =
          state.latestFound &&
          latestFloor &&
          _.findIndex(state.floors, ["id", latestFloor.id]) > -1
            ? _.find(state.floors, ["id", latestFloor.id])
            : state.floors[0];
        myStorage.set("library", newValue);
      }
    );
    watch(
      () => state.floor,
      async (newValue) => {
        state.rooms = newValue.room.filter(
          (item) => item.isValid == 1 && item.webhidden == 0
        );
        if (state.rooms.length===0) {
          Toast.fail("暂无数据");
          return;
        }
        let latestRoom = myStorage.get("latestRoom");
        state.room =
          state.latestFound &&
          latestRoom &&
          _.findIndex(state.rooms, ["id", latestRoom.id]) > -1
            ? _.find(state.rooms, ["id", latestRoom.id])
            : state.rooms[0];
        myStorage.set("floor", newValue);
        myStorage.set("room", state.room);
      }
    );
    const getLatestBooking = async () => {
      try {
        const {
          data: { list },
        } = await getMyBookings({
          access_token: user.access_token,
          userid: user.userid,
        });
        let latestRoomBooking = _.filter(list, { isSingle: 0 })[0];
        if (latestRoomBooking) {
          myStorage.set(
            "latestLibOfRoom",
            latestRoomBooking.spaceDetailInfo.areaInfo.parentAreaInfo[0]
          );
          myStorage.set(
            "latestFloorOfRoom",
            latestRoomBooking.spaceDetailInfo.areaInfo.parentAreaInfo[1]
          );
          myStorage.set(
            "latestRoom",
            latestRoomBooking.spaceDetailInfo.areaInfo.parentAreaInfo[2]
          );
        }
      } catch (error) {
        Toast.fail(error.message);
      }
    };
    const init = async () => {
      try {
        const { data } = await getRoomOpenDays();
        state.days = [];
        for (let i = 0; i < data[0].bookday; i++) {
          state.days.push(dayjs().add(i, "day").format("YYYY-MM-DD"));
        }
        state.day = state.day || state.days[0];
        myStorage.set("day", state.day);
        await loadRooms();
      } catch (error) {
        Toast.fail(error.message);
      }
    };
    const loadRooms = async () => {
      state.libraries.length = 0;
      const rooms = await getRooms({date:state.day});
      if (rooms.status != 1) {
        Toast.fail("暂无数据");
        return;
      }
      myStorage.set("allRooms", rooms.data.list);
      state.libraries = rooms.data.list
        .filter((item) => item.isValid === 1 && item.webhidden === 0);
      if (state.libraries.length==0) {
        Toast.fail("暂无数据");
        return;
      }
      let latestLib = myStorage.get("latestLibOfRoom");
      [state.latestFound, state.library] =
        latestLib && _.findIndex(state.libraries, ["id", latestLib.id]) > -1
          ? [true, latestLib]
          : [false, state.libraries[0] || state.library];
    };
    const refresh = () => {
      init();
    };

    const goBack = () => router.go(-1);
    const selectDay = (day) => {
      state.day = day;
      myStorage.set("day", state.day);
      loadRooms();
    };
    const selectLibrary = (lib) => {
      state.library = lib;
    };
    const selectFloor = (fl) => {
      state.floor = fl;
    };
    const selectRoom = (room) => {
      state.room = room;
      myStorage.set("room", room);
    };
    const goBookingRoom = () => {
      router.push("/bookRoom");
    };
    const goHome = () => router.push("/index");
    return {
      goBack,
      selectDay,
      selectLibrary,
      selectFloor,
      selectRoom,
      goBookingRoom,
      refresh,
      goHome,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
</style>
